<template>
  <div ref="background" class="background">
    <template v-if="loader.loaded && !loader.show">
      <v-container>
        <v-row>
          <v-col
            lg="3"
            md="4"
            sm="6"
            cols="12"
            v-for="screenplay in screenplays"
            :key="screenplay.id"
          >
            <v-card
              @click="$router.push(`/screenplay/${screenplay.id}?${actionMode ? 'actionMode=enable&' : ''}`)"
            >
              <v-card-text>
                <div
                  class="screenplay-name headline overflow-dot mb-1 ml-2"
                  :title="screenplay.name || screenplay.id"
                  v-text="screenplay.name || screenplay.id"
                >
                </div>
                <div class="screenplay-author subtitle-2 overflow-dot mb-2 ml-2">{{screenplay.authorName || 'empty'}}</div>
                <p class="screenplay-desc pa-2 pl mb-0">
                  {{screenplay.description}}
                </p>
              </v-card-text>
              <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="$router.push(`/screenplay/${screenplay.id}?${actionMode ? 'actionMode=enable&' : ''}`)">
                  DETAIL
                </v-btn>
              </v-card-actions> -->
            </v-card>
          </v-col>
          <v-col
            class="d-flex justify-center"
            cols="12"
          >
            <v-btn :to="prevPage" @click.prevent="changePage(currentPage - 1)" :disabled="!prevPage" style="margin-right: 2rem;">上一頁</v-btn>
            <v-btn :to="nextPage" @click.prevent="changePage(currentPage + 1)" :disabled="!nextPage">下一頁</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <!-- #Loader -->
    <transition name="fade">
      <v-dialog
        v-model="loader.show"
        hide-overlay
        :persistent="!loader.loaded"
        max-width="300"
      >
        <v-card
          color="secondary"
        >
          <v-card-text class="white--text" style="padding-top: 15px">
            <transition name="fade">
              <div v-if="!loader.loaded">
                <span v-text="loader.text"></span>
                <v-progress-linear
                  indeterminate
                  color="white"
                  class="mb-0"
                ></v-progress-linear>
              </div>
            </transition>
          </v-card-text>
        </v-card>
      </v-dialog>
    </transition>
    <!-- 右鍵選單 -->
    <v-menu
      v-model="contextmenu.show"
      :position-x="contextmenu.x"
      :position-y="contextmenu.y"
      fixed
      offset-y
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <!-- <v-list-item-title>save playback</v-list-item-title> -->
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div> <!-- .background -->
</template>

<script>
// import { VueTyper } from 'vue-typer'
import Assistant from '../lib/Assistant'
import Screenplay from '@/lib/Screenplay'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
let assistant = Assistant.getInstance()

export default {
  name: 'index',
  components: {
  },
  computed: {
    actionMode(){
      return this.$store.state.actionMode
    },
    /**
     * google assistant的預留空間
     */
    assistantHeaderHeight(){
      return this.$store.state.assistantHeaderHeight
    },
    nextPage(){
      if(this.currentPage === 0){
        return `/?p=1`
      }
      if(this.currentPage * this.countPerPage < this.screenplayTotal){
        return `/?p=${this.currentPage + 1}`
      }
      return null
    },
    prevPage(){
      if(this.currentPage >= 1){
        return `/?p=${this.currentPage - 1}`
      }
      return null
    }
  },
  watch: {
  },
  data: ()=>{
    return {
      screenplays: [],
      // 資料庫有的數量
      screenplayTotal: 0,
      // 每頁的資料筆數 ( min:10, max:50 )
      countPerPage: 20,
      currentPage: 0,
      contextmenu: {
        x: 0,
        y: 0,
        show: false
      },
      loader: {
        text: 'Loading',
        show: true,
        loaded: false
      }
    }
  },
  mounted(){
    this.$store.commit('appbar/backTo', `$disable`)
    // 備註：上下頁切換時，因為只改 query 所以不會觸發 mounted
    let page = parseInt(this.$route.query.p)
    if(Number.isNaN(page)) page = 0
    this.changePage(page)
  },
  updated(){
  },
  beforeDestroy(){
  },
  methods: {
    async updateScreenplayTotalCount(){
      try{
        this.screenplayTotal = await gameLoader.getScreenplayCount()
      }catch(e){
        console.warn('get screenplayTotal failed')
        this.screenplayTotal = -1
      }
      return this.screenplayTotal
    },
    async changePage(page){
      this.currentPage = page
      await this.updateScreenplayTotalCount()
      await this.updatePageContent(page)
    },
    updatePageContent(page = 1){
      this.loader.show = true
      return gameLoader.getScreenplays(page, this.countPerPage)
        .then((list)=>{
          window.scrollTo(0, 0)
          this.screenplays = list.filter((item)=>!item.id.match(/\.js/)).map((item)=>new Screenplay(item))
          this.loader.show = false
          this.loader.loaded = true
        })
    }
  }
}
</script>
<style>
.main-content{
  background-color: #15202B;
}
.vue-typer .custom.char{
  color: white;
}
</style>
<style scoped>
  .h-100{
    height: 100%;
  }
  .background{
    height: 100%;
    overflow-y: auto;
    background-color: #15202B;
    color: white;
  }
  .overflow-dot{
    white-space : nowrap;
    text-overflow : ellipsis;
    overflow: hidden;
  }
  .v-card .screenplay-desc{
    height: 100px;
    overflow-y:scroll;
    background-color:rgba(0, 0, 0, 0.1)
  }
</style>
